import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-645c5774"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "category-wrapper" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Attachments", -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Activities", -1))
const _hoisted_6 = [
  _hoisted_5
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categories, (category) => {
      return (_openBlock(), _createElementBlock("div", {
        key: category.id,
        class: _normalizeClass({
        'category-item': true,
        'category-item-active': category.id === _ctx.currentCategory,
      }),
        onClick: ($event: any) => (_ctx.openCategory(category.id))
      }, [
        _createElementVNode("div", null, _toDisplayString(category.name), 1)
      ], 10, _hoisted_2))
    }), 128)),
    _createElementVNode("div", {
      class: _normalizeClass({
        'category-item': true,
        'category-item-active': _ctx.currentCategory === _ctx.ATTACHMENTS_ID,
      }),
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openAttachments && _ctx.openAttachments(...args)))
    }, _hoisted_4, 2),
    _createElementVNode("div", {
      class: _normalizeClass({
        'category-item': true,
        'category-item-active': _ctx.currentCategory === _ctx.ACTIVITY_ID,
      }),
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.openActivity && _ctx.openActivity(...args)))
    }, _hoisted_6, 2)
  ]))
}